import React, { FC } from "react";
import { faCog } from "@fortawesome/pro-regular-svg-icons/faCog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Cog: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faCog} {...props} />
);
